import { axiosInstance, getFullHeader } from '@services/base-service';
import { v4 as uuidv4 } from 'uuid';

const transactionsUri = '/merchant/bff/transactions';
const banksUri = '/bff/bank-service/v1';

export const getAvailable = () =>
  axiosInstance.getInstance().get(`${transactionsUri}/creditor-account`);

export const doFundsOut = (id, amount) =>
  axiosInstance.getInstance().post(`${transactionsUri}/funds-out/${id}`, {
    payload: { amount: parseFloat(amount), currency: 'CLP', trx_id: uuidv4() },
  });

export const doCashOut = (id, amount) =>
  axiosInstance.getInstance().post(`${transactionsUri}/cash-out/${id}`, {
    payload: { amount: parseFloat(amount), trx_id: uuidv4() },
  });

export const getBalances = ({ id, start, end }) =>
  axiosInstance.getInstance().get(`${transactionsUri}/transactions/total/${id}/${start}/${end}`);

export const getBanksNames = () =>
  axiosInstance.getInstance().get(`${transactionsUri}/banks`, { headers: getFullHeader() });

export const getAccountTypes = () => axiosInstance.getInstance().get(`${banksUri}/account-types`);
